/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UnpauseNeighborhoodProgramRequest} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'
import {UnpauseNeighborhoodProgramResponse} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'


export const unpauseNeighborhoodProgram = (request: UnpauseNeighborhoodProgramRequest, options?: CashRequestOptions) => post<UnpauseNeighborhoodProgramRequest, UnpauseNeighborhoodProgramResponse>("/2.0/cash/unpause-neighborhood-program", request, {...options, rejectOnError: true })